'use client'

import { TextLink } from '@lastbrand/web-ui/text-link'
import { cx } from '@lastbrand/web-ui-styled-system/css'
import { useTranslation } from 'next-i18next'
import { useState } from 'react'

import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'

import { containerCss, toggleLinkStyle } from './read-more-ds.styles'

export interface ReadMoreDSProps {
  children: string
  className?: string
  maxLength?: number
}

export const ReadMoreDS = ({ children, className, maxLength = 146 }: ReadMoreDSProps) => {
  const text = children
  const size = text.length
  const [isReadMore, setIsReadMore] = useState(true)
  const { t } = useTranslation('common')
  const { deviceType } = useDeviceInfo()
  const toggleReadMore = () => {
    setIsReadMore(prevState => !prevState)
  }
  const isTruncated = size > maxLength
  // eslint-disable-next-line i18next/no-literal-string
  const linkSize = deviceType === DEVICE_TYPES.MOBILE ? 'md' : 'lg'

  return (
    <div data-testid="read-more" data-max-length={maxLength.toString()} className={cx(containerCss, className)}>
      {isReadMore && isTruncated ? text.slice(0, maxLength) : text}
      {isTruncated && (
        <>
          {/* The ellipsis stands in for the truncated tail — only show it while collapsed. */}
          {isReadMore ? <>{t('ellipsis')} </> : ' '}
          <TextLink onClick={toggleReadMore} css={toggleLinkStyle} size={linkSize}>
            {isReadMore ? t('read_more') : t('show_less')}
          </TextLink>
        </>
      )}
    </div>
  )
}

export default ReadMoreDS
